<template>
  <div class="zz-main-inner">
    <div
      v-if="showHeader"
      class="zz-main-inner-header">
      <div class="title">
        <el-page-header
          v-if="showBack"
          @back="goBack"></el-page-header>
        {{ title || $route.meta.name }}
        <slot name="title"></slot>
      </div>
      <slot name="action"></slot>
    </div>
    <slot></slot>
    <div class="main-inner-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LayoutMainInner',
  props: {
    showBack: { type: Boolean, default: false },
    title: String,
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    goBack() {
      this.callBack && this.callBack()
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="stylus" scoped>
.zz-main-inner {
  min-width: 1100px;
  margin: 15px;

  .zz-main-inner-header {
    background-color: #fff;
    height: 48px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    .title {
      font-size: 18px;
      font-weight: 600;
      display: flex;
      align-items: center;
    }
  }

  .main-inner-footer {
    margin-top: 10px;
    text-align: center;
  }
}
</style>
